import React from 'react';

const SearchContact = ({
  searchResults,
  changeCurrentChat,
  sortedContacts,
  currentSelected,
  onContactClick // ✅ NEW PROP
}) => {

  return (
    <div className="contacts">
      {searchResults.length > 0 ? (
        searchResults.map((contact, index) => {
          return (
            <div
              key={contact._id}
              className={`contact ${
                index === currentSelected ? "selected" : ""
              }`}
              onClick={() => {
                if (onContactClick) {
                  onContactClick(index, contact); // ✅ use popup flow
                } else {
                  changeCurrentChat(index, contact); // fallback (old behavior)
                }
              }}
            >
              <div className="avatar">
                {contact.avatarImage ? (
                  <>
                    {contact.avatarImage.startsWith("https://") || contact.avatarImage.includes("https") ? (
                      <img
                        src={contact.avatarImage}
                        alt={`${contact.username}'s avatar`}
                      />
                    ) : (
                      <img
                        src={`data:image/svg+xml;base64,${contact.avatarImage}`}
                        alt={`${contact.username}'s avatar`}
                      />
                    )}
                  </>
                ) : (
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAIAAADTED8xAAADMElEQVR4nOzVwQnAIBQFQYXff81RUkQCOyDj1YOPnbXWPmeTRef+/3O/OyBjzh3CD95BfqICMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMO0TAAD//2Anhf4QtqobAAAAAElFTkSuQmCC"
                    alt="Default Avatar"
                  />
                )}
                <b>
                  <p style={{ margin: "0" }}>{contact.username}</p>
                </b>
              </div>
            </div>
          );
        })
      ) : (
        <p>No results found {sortedContacts.length}!</p>
      )}
    </div>
  );
};

export default SearchContact;